import moment from "moment";
import theme from "../../theme";
import { currentUserHasMoney, MONEY_MASK } from "../../lib/permissions";

// Money values arrive as JSON numbers with 2 decimals. Render as NGN currency.
export const formatCurrency = (value) => {
  // financials.view gate: mask monetary values for users without it.
  if (!currentUserHasMoney()) return MONEY_MASK;
  const num = Number(value);
  if (value === null || value === undefined || Number.isNaN(num)) return "—";
  return new Intl.NumberFormat("en-NG", {
    style: "currency",
    currency: "NGN",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
};

// ISO date -> localized, with a graceful dash for null.
export const formatDateTime = (value) => {
  if (!value) return "—";
  const m = moment(value);
  return m.isValid() ? m.format("lll") : "—";
};

export const formatDate = (value) => {
  if (!value) return "—";
  const m = moment(value);
  return m.isValid() ? m.format("ll") : "—";
};

// <input type="datetime-local"> wants `YYYY-MM-DDTHH:mm`; API wants full ISO.
export const isoToLocalInput = (value) => {
  if (!value) return "";
  const m = moment(value);
  return m.isValid() ? m.format("YYYY-MM-DDTHH:mm") : "";
};

export const localInputToIso = (value) => {
  if (!value) return null;
  const m = moment(value);
  return m.isValid() ? m.toISOString() : null;
};

// Categories — kept data-driven so future categories render without layout changes.
export const CATEGORY_OPTIONS = [{ value: "SIGNUP", label: "Signup" }];

export const categoryLabel = (value) => {
  if (!value) return "—";
  const match = CATEGORY_OPTIONS.find((c) => c.value === value);
  if (match) return match.label;
  // Fallback: humanize an unknown future category (e.g. "REFERRAL" -> "Referral").
  return value
    .toString()
    .toLowerCase()
    .replace(/(^|[\s_])\w/g, (s) => s.toUpperCase())
    .replace(/_/g, " ");
};

// Claim state visual + textual meta. Display only — the admin never acts on these.
export const CLAIM_STATE_META = {
  PENDING: {
    label: "Pending",
    color: "#B7791F", // amber text
    bg: "#FEF3C7",
    description: "Payout in flight — still settling. Not final.",
  },
  REDEEMED: {
    label: "Redeemed",
    color: theme.colors.ApproveGreen,
    bg: "#DCFCE7",
    description: "Paid into the employee's bank account.",
  },
  FAILED: {
    label: "Failed",
    color: theme.colors.RejectRed,
    bg: theme.colors.Cinderella,
    description: "Payout declined or reversed. The employee can retry from their app.",
  },
};

export const CLAIM_STATE_OPTIONS = [
  { value: "", label: "All states" },
  { value: "PENDING", label: "Pending" },
  { value: "REDEEMED", label: "Redeemed" },
  { value: "FAILED", label: "Failed" },
];

export const ACTIVE_FILTER_OPTIONS = [
  { value: "", label: "All" },
  { value: "true", label: "Active" },
  { value: "false", label: "Inactive" },
];

export const PAGE_SIZE = 10;

// Normalize a reducer error (string | string[]) into an array for notistack.
export const toMessages = (error, fallback = "Something went wrong.") => {
  if (!error) return [fallback];
  if (Array.isArray(error)) return error.filter(Boolean).length ? error.filter(Boolean) : [fallback];
  if (typeof error === "string") return [error];
  if (typeof error?.message === "string") return [error.message];
  return [fallback];
};
